var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"tableTitle":_vm.tableTitle,"searchUrl":_vm.url,"tableType":3,"form":_vm.form,"scale_title":true,"add":false,"operation-list":_vm.operationList,"operation-left":false,"searchTime":true,"back":{},"pageFooter":true},on:{"operation-click":_vm.edit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }